var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationChevronsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.6 1.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.89851 6.4L6.94925 11.3582C7.11642 11.5223 7.2 11.7216 7.2 11.956C7.2 12.1905 7.11642 12.3897 6.94925 12.5538C6.78209 12.7179 6.5791 12.8 6.3403 12.8C6.10149 12.8 5.89851 12.7179 5.73134 12.5538L0.376119 7.2967C0.244776 7.16777 0.149254 7.02711 0.0895522 6.87473C0.0298507 6.72234 0 6.5641 0 6.4C0 6.2359 0.0298507 6.07766 0.0895522 5.92527C0.149254 5.77289 0.244776 5.63223 0.376119 5.5033L5.73134 0.246154C5.89851 0.0820513 6.10149 0 6.3403 0C6.5791 0 6.78209 0.0820513 6.94925 0.246154C7.11642 0.410256 7.2 0.609524 7.2 0.843956C7.2 1.07839 7.11642 1.27766 6.94925 1.44176L1.89851 6.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49851 6.4L12.5493 11.3582C12.7164 11.5223 12.8 11.7216 12.8 11.956C12.8 12.1905 12.7164 12.3897 12.5493 12.5538C12.3821 12.7179 12.1791 12.8 11.9403 12.8C11.7015 12.8 11.4985 12.7179 11.3313 12.5538L5.97612 7.2967C5.84478 7.16777 5.74925 7.02711 5.68955 6.87473C5.62985 6.72234 5.6 6.5641 5.6 6.4C5.6 6.2359 5.62985 6.07766 5.68955 5.92527C5.74925 5.77289 5.84478 5.63223 5.97612 5.5033L11.3313 0.246154C11.4985 0.0820513 11.7015 0 11.9403 0C12.1791 0 12.3821 0.0820513 12.5493 0.246154C12.7164 0.410256 12.8 0.609524 12.8 0.843956C12.8 1.07839 12.7164 1.27766 12.5493 1.44176L7.49851 6.4Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationChevronsLeft);
export default __webpack_public_path__ + "static/media/Pagination_chevrons_left.84cfaba6ed81cafd8ca6b82107b2ef6d.svg";
export { ForwardRef as ReactComponent };